import { useCallback } from 'react';

export const useErrorReporting = () => {
  const reportError = useCallback((error, context = {}) => {
    console.error('🚨 Error:', error, 'Context:', context);
  }, []);

  const reportWarning = useCallback((warning, context = {}) => {
    console.warn('⚠️ Warning:', warning, 'Context:', context);
  }, []);

  const reportInfo = useCallback((info, context = {}) => {
    console.info('ℹ️ Info:', info, 'Context:', context);
  }, []);

  const getStoredErrors = useCallback(() => {
    return [];
  }, []);

  const clearStoredErrors = useCallback(() => {
    return true;
  }, []);

  return {
    reportError,
    reportWarning,
    reportInfo,
    getStoredErrors,
    clearStoredErrors
  };
}; 